module.exports = __webpack_public_path__ + "static/img/bg.3d8e150.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/specialist/bg.png
// module id = s6GV
// module chunks = 1